export const origins = [
  "DTS",
  "MOBILE_APP",
  "POINT_OF_SALES",
  "CALL_CENTER",
  "INDUSTRY_PROGRAM_WEBSITE",
  "INTERACTIVE_VOICE_RESPONSE",
  "VACCINES_INDUSTRY_PROGRAM_WEBSITE",
  "PURCHASE",
  "AZIMUTE",
  "PARTNERS_ECOMMERCE",
  "MANAGER_SYSTEM",
  "FACEBOOK",
  "ELECTRONIC_PRESCRIPTION",
  "CCUCO",
  "BCARE",
];
